import { prefetchModelIndex } from '@rhino-project/core/hooks';
import { createFileRoute } from '@tanstack/react-router';
import PlayersPage from '../../../../pages/players/PlayersPage';

export const Route = createFileRoute('/_authenticated/$owner/players/')({
  loader: ({ context: { rhino } }) => {
    return prefetchModelIndex(rhino, 'player');
  },
  component: RouteComponent
});

function RouteComponent() {
  return <PlayersPage />;
}
